import type { NoneAddressInputs } from '@/store/models/form/types';
import { appStore } from '@/store';
import { getDefaultInputState } from '@/store/models/utils';
import { features } from '@/lib';

/**
 * This is a helper function that will keep the state clean for full names.
 * When there is a nationality or signup vs guest change,
 * and buyers are eligible for shouldDisplayJpKanaAndKanjiNames, we should
 * clean up the state of the full name fields to avoid any undesirable behavior
 */
export const verifyAndResetFullNames = (): void => {
  if (features.isActive('shouldDisplayJpKanaAndKanjiNames')) {
    const { form: formActions } = appStore.getActions();
    const nameFields: Array<keyof NoneAddressInputs> = [
      'firstName',
      'lastName',
      'countrySpecificFirstName',
      'countrySpecificLastName',
    ];

    nameFields.forEach(field => {
      formActions.updateNonAddressField({
        field,
        payload: getDefaultInputState(),
      });
    });
  }
};
